import React, {Dispatch, FC, SetStateAction, useState} from 'react'
import {useFormik} from 'formik'
import {Tooltip, Whisper} from 'rsuite'
import {KTSVG} from '../../../../_metronic/helpers'
import {ActionsButton} from '../../../../_metronic/partials/widgets/tables/components/ActionsButtons'
import {Subscriber} from '../contacts/types'
import * as Yup from 'yup'
import {useStatusMessage} from '../../../features'
import {Put} from '../../../../setup/axios/requests'
import {useMailing} from '../../../@types'

type RowUpdateType = {
  item: Subscriber,
  handleEditClick: (id: number) => void,
  setEditingRow: Dispatch<SetStateAction<number>>
}

const UpdateSchema = Yup.object().shape({
  first_name: Yup.string()
    .min(3, 'Au moins 3 lettres')
    .max(15, 'Maximum 15 lettres')
    .required('Prénom est obligatoire'),
  last_name: Yup.string()
    .min(3, 'Au moins 3 lettres')
    .max(15, 'Maximum 15 lettres')
    .required('Nom est obligatoire'),
  email: Yup.string()
    .email('Format d\'e-mail incorrect')
    .min(12, 'Au moins 12 symboles')
    .max(50, 'Maximum 50 symboles')
    .required('e-mail est obligatoire'),
  subscribed: Yup.string()
    .oneOf(['0', '1'], 'Selection invalide') // Allow only "0" or "1"
    .required('Champ requis'),
})
type initialValuesUpdateType = {
  first_name: string,
  last_name: string,
  email: string,
  subscribed: '0' | '1',
}

const subscription = [
  {value: 0, title: 'Désabonné'},
  {value: 1, title: 'Abonné'},
]

const UPDATE = process.env.REACT_APP_MAILING_GET_UPDATE_ONE_CONTACTS_LISTS || 'v2/subscribers-edit'


const ContactRowUpdate: FC<RowUpdateType> = ({item, handleEditClick, setEditingRow}) => {

  const {triggerReload} = useMailing()
  const {formState, setLoading} = useStatusMessage()
  const [bg, setBg] = useState<"" | "success" | "danger">("")

  const onSubmit = async (values: initialValuesUpdateType, {setSubmitting}: {
    setSubmitting: (isSubmitting: boolean) => void
  }) => {

    setLoading(true)

    try {

      const data = {...values, ids: [item.id]}

      const {status} = await Put<{status: number, message: string}>(UPDATE, data)

      if (status === 200) {
        setLoading(false)
        setBg('success')
        setTimeout(() => {
          setEditingRow(-1)
        }, 2000)
        triggerReload()
      } else {
        setBg('danger')
      }

    } catch (e) {
      console.log(e)
    } finally {

    }

  }

  const formik = useFormik({
    initialValues: {
      email: item.email || '',
      last_name: item.last_name || '',
      first_name: item.first_name || '',
      subscribed: item.unsubscribed_at ? '0' : '1',
    },
    validationSchema: UpdateSchema,
    enableReinitialize: true,
    onSubmit,
  })

  console.log()

  return (
    <tr className={`bg-light-${bg}`}>
      <td>
      </td>
      <td>
        <span className="text-dark fw-bolder fs-6">{item.created_at}</span>
      </td>
      <td>
        <input type="email"
               className={`form-control form-control-solid form-control-sm px-1 ${formik.errors.email && 'border-danger'}`}
               placeholder="e-mail"
               {...formik.getFieldProps('email')}
        />
      </td>
      <td>
        <input type="text"
               className={`form-control form-control-solid form-control-sm px-1 ${formik.errors.last_name && 'border-danger'}`}
               placeholder="Nom"
               {...formik.getFieldProps('last_name')}
        />
      </td>
      <td>
        <input type="text"
               className={`form-control form-control-solid form-control-sm px-1 ${formik.errors.first_name && 'border-danger'}`}
               placeholder="Prénom"
               {...formik.getFieldProps('first_name')}
        />
      </td>
      <td>
        <select className="form-select form-select-solid form-select-sm"
                {...formik.getFieldProps('subscribed')}
        >
          {
            subscription.map((i, index) => (
              <option value={i.value} key={index}>{i.title}</option>
            ))
          }
        </select>
      </td>
      <td className="text-center">
        <form onSubmit={formik.handleSubmit} className="d-flex flex-row justify-content-center">
          <Whisper placement="top" controlId="control-id-click" trigger="hover"
                   speaker={<Tooltip>Éditer</Tooltip>}>
            <button className="btn btn-sm btn-icon btn-active-light-primary me-1"
                    type="submit"
                    disabled={formik.isSubmitting || !formik.isValid}

            >
              {
                formState.loading
                  ? (
                    <span className="indicator-progress text-primary" style={{display: 'block'}}>
                      <span className="spinner-border spinner-border-sm align-middle" />
                    </span>
                  ) : <KTSVG path={'/media/icons/duotune/general/gen037.svg'} className="svg-icon-3 svg-icon-primary" />
              }
            </button>
          </Whisper>

          <ActionsButton tooltip="Annuler"
                         iconPath="/media/icons/duotune/abstract/abs012.svg"
                         iconClass="svg-icon-3 svg-icon-danger"
                         className="btn btn-sm btn-icon btn-active-light-danger"
                         onClick={() => handleEditClick(-1)}
          />
        </form>

      </td>
    </tr>
  )
}

export {ContactRowUpdate}